import styles from "./styles.module.scss"
import cn from "clsx"
import type { FC, HTMLAttributes } from "react"


interface ArrowProps
extends HTMLAttributes<SVGSVGElement> {}

export const Arrow: FC<ArrowProps> = ({ className, ...props }) => (
  <svg className={cn(styles.arrow, className)} width="15" height="18" viewBox="0 0 15 18" fill="none" {...props}>
    <path d="M0.5 1.20577L14 9L0.5 16.7942L0.5 1.20577Z" stroke="var(--color-gold)"/>
  </svg>
)
